const METRIKA_ID = 81056569

let initialized = false

export function initYandexMetrika() {
  if (initialized || typeof window === 'undefined') {
    return
  }

  initialized = true

  window.ym = window.ym || function ymStub() {
    (window.ym.a = window.ym.a || []).push(arguments)
  }
  window.ym.l = Date.now()

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://mc.yandex.ru/metrika/tag.js'
  document.head.appendChild(script)

  window.ym(METRIKA_ID, 'init', {
    defer: true,
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
  })
}
